import { render, staticRenderFns } from "./thirdSam.vue?vue&type=template&id=57a1496e&scoped=true"
import script from "./thirdSam.vue?vue&type=script&lang=js"
export * from "./thirdSam.vue?vue&type=script&lang=js"
import style0 from "./thirdSam.vue?vue&type=style&index=0&id=57a1496e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a1496e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57a1496e')) {
      api.createRecord('57a1496e', component.options)
    } else {
      api.reload('57a1496e', component.options)
    }
    module.hot.accept("./thirdSam.vue?vue&type=template&id=57a1496e&scoped=true", function () {
      api.rerender('57a1496e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/thirdSam/thirdSam.vue"
export default component.exports